import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
  selectedTabIndex: string;
}

const initialState: StateInterface = {
  isFetching: false,
  fields: [],
  translatedMessage: "",
  selectedTabIndex: Constants.COMPANY_DETAILS_OVERVIEW_TAB
};

export const companyUpdateReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.PAGE_CONTACT_COMPANY_UPDATE_REQUEST:
      return {...state,
        isFetching: true
      };

    case Constants.PAGE_CONTACT_COMPANY_UPDATE_SUCCESS:
      return {...state,
        isFetching: false
      };

    case Constants.PAGE_CONTACT_COMPANY_UPDATE_FAILURE:
      return {...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.PAGE_CONTACT_COMPANY_UPDATE_CLEAR:
      return {
        ...initialState
      };

    case Constants.PAGE_CONTACT_COMPANY_UPDATE_SWITCH_TAB:
        return {
          ...state,
          selectedTabIndex: action.payload?.index
        };

    case Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE:
      return {
        ...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

      case Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE:
        return {
          ...state,
          fields: action.payload?.err.fields || [],
          translatedMessage: action.payload?.err.translatedMessage
        };

    case Constants.GLOBAL_DEPOSIT_TO_OWNER_SAVINGS_FAILURE:
      return {
        ...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_FAILURE:
      return {
        ...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

  
    case Constants.GLOBAL_AGENCY_FEE_UPDATE_FAILURE:
      return {
        ...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.PAGE_CONTACT_COMPANY_UPDATE_CLEAR:
    case Constants.COACH_ERRORS_CLEAR:
      return {
        ...initialState
      };

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
